import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import styles from './PaymentSuccessPage.module.css';

const PaymentSuccessPage = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const response = await fetch('/api/get-order', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ orderId }),
        });

        if (response.ok) {
          const data = await response.json();
          setOrder(data);
        }
      } catch (error) {
        console.error('Error fetching order details:', error);
      } finally {
        setLoading(false);
      }
    };

    if (orderId) {
      fetchOrderDetails();
    }
  }, [orderId]);

  if (loading) {
    return <div className={styles.container}>Loading order details...</div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.checkmarkCircle}>
          <div className={styles.checkmark}>✓</div>
        </div>
        
        <h1 className={styles.title}>Payment Successful</h1>
        <p className={styles.message}>
          Thank you for your order! Your payment has been processed successfully.
        </p>
        
        <div className={styles.orderDetails}>
          <h2>Order #{orderId.slice(-6)}</h2>
          {order && (
            <>
              <p><strong>Subtotal:</strong> ${parseFloat(order.total_amount).toFixed(2)}</p>
              {order.tip_amount > 0 && (
                <p><strong>Tip:</strong> ${parseFloat(order.tip_amount).toFixed(2)}</p>
              )}
              <p><strong>Total:</strong> ${(parseFloat(order.total_amount) + parseFloat(order.tip_amount || 0)).toFixed(2)}</p>
              <p><strong>Order Status:</strong> {order.status}</p>
              <p><strong>Order Time:</strong> {new Date(order.created_at).toLocaleString()}</p>
            </>
          )}
        </div>
        
        <div className={styles.actions}>
          {order && (
            <Link to={`/menu/${order.restaurant_id}`} className={styles.button}>
              Return to Menu
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;